import React from 'react';
import { XIcon } from 'lucide-react';
interface RightPanelProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}
export const RightPanel = ({
  isOpen,
  onClose,
  children
}: RightPanelProps) => {
  return <div className={`fixed right-0 top-0 h-screen w-[400px] bg-[#1f1f1f] border-l border-[#444444] transform transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-166">
      <div className="flex justify-between items-center p-4 border-b border-[#444444]" data-id="element-167">
        <h2 className="font-semibold" data-id="element-168"></h2>
        <button onClick={onClose} className="p-2 hover:bg-[#2a2a2a] rounded-lg transition-colors" data-id="element-169">
          <XIcon size={20} className="text-[#888888]" data-id="element-170" />
        </button>
      </div>
      <div className="p-4 overflow-y-auto h-[calc(100vh-64px)]" data-id="element-171">{children}</div>
    </div>;
};